<template>
  <button class="pi-button"
          :class="className"
          @click="btnClick">
    <img src="@/assets/img/loading-btn.png"
         alt=""
         class="loading-img rotate-div"
         v-if="type=='loading'">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'pi-button',
  data () {
    return {
      className: ''
    };
  },
  methods: {
    dataWctch () {
      if (this.type) {
        this.className = this.type;
      } else {
        this.className = 'on';
      }
      if (this.block) {
        this.className = this.className + ' block';
      }
      if (this.size) {
        this.className = this.className + ' ' + this.size;
      }
      if (this.fixed) {
        this.className = this.className + ' fixed-btn';
      }
    },
    btnClick () {
      if (this.type !== 'default' && this.type !== 'loading') {
        this.$emit('click');
      }
    }
  },
  mounted () {
    this.dataWctch();
  },
  props:{
    type: {
      type:String,
      default: '',
    },
    block: {
      type:Boolean,
      default: false,
    },
    size: {
      type:String,
      default: '',
    },
    fixed: {
      type:Boolean,
      default: false,
    },
  },
  watch: {
    'type': function () {
      this.dataWctch();
    },
    'fixed': function () {
      this.dataWctch();
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../../assets/less/old/var.less";
.pi-button {
  height: 0.94rem;
  color: #fff;
  font-size: 0.4rem;
  border-radius: 0.16rem;
  border: none;
  padding: 0 0.2rem;
}

.pi-button.on {
  border: 1px solid @main-color;
  background-color: transparent;
  color: @main-color;
}

.pi-button.primary {
  background-color: @main-color;
}
.pi-button.text {
  color: @main-color;
}
.pi-button.default {
  background-color: #bff3dd;
}
.pi-button.danger {
  background-color: @red;
}
.pi-button.loading {
  background-color: #79e4b7;
  .loading-img {
    width: 0.34rem;
  }
}
.pi-button.warning {
  background-color: @orange;
}
.pi-button.block {
  display: block;
  width: 100%;
}
.pi-button.primary:active {
  background-color: #79e4b7;
}
.pi-button.on:active {
  opacity: 0.7;
}
.pi-button.small {
  // border-radius: 0.1rem;
  height: 0.72rem;
  font-size: 0.36rem;
}
.pi-button.mini {
  border-radius: 0.12rem;
  height: 0.5rem;
  font-size: 0.28rem;
}
.pi-button.fixed-btn {
  position: fixed;
  width: 100%;
  border-radius: 0;
  left: 0;
  bottom: 0;
  z-index: 8;
}
</style>
